import React from 'react';
import PropTypes from 'prop-types';
import RouterContext from 'react-router/lib/RouterContext';

const QueryRoutingContainer = ({ query, location }, { queryRoutingResults }) => {
  if (queryRoutingResults[query]) {
    return <RouterContext {...queryRoutingResults[query]} location={location} />;
  }

  return <noscript />;
};

QueryRoutingContainer.contextTypes = {
  queryRoutingResults: PropTypes.objectOf(PropTypes.any),
};

QueryRoutingContainer.propTypes = {
  query: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
};

export default QueryRoutingContainer;
